import { apiClient } from '~/shared/api/data-ingestion-api'
import { type DocumentPageRange } from './types'

export function getExistingDocumentPageRanges(
  documents: apiClient.Document[],
  newDocumentPageRanges: DocumentPageRange[],
) {
  return newDocumentPageRanges.map((newRange) => {
    const matchedDocument = documents.find(
      (doc) =>
        doc.page_range.start_page === newRange.pageRange.startPage &&
        doc.page_range.end_page === newRange.pageRange.endPage,
    )
    if (matchedDocument) {
      return {
        ...newRange,
        documentId: matchedDocument.key,
        // TODO: use `matchedDocument.confidence_score` when API is ready
        confidenceScore: 1,
      }
    }
    return newRange
  })
}
